var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{staticClass:"mt-5 pt-5",attrs:{"align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs10":"","sm6":"","md4":""}},[_c('v-card',{staticClass:"mt-5"},[_c('v-alert',{attrs:{"value":true,"type":"warning"}},[_vm._v("\n        Интерфейс на переработке\n      ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }